import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const ACTION_HIDE = gql`
  mutation ActionHideFun($contentGroupId: Int!, $targetSnippetId: Int!) {
    contentGroup {
      addAction(
        actionHide: {
          contentGroupId: $contentGroupId
          targetSnippetId: $targetSnippetId
        }
      ) {
        id
      }
    }
  }
`;

const ActionHide = ({
  contentGroupId,
  targetSnippetId,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={ACTION_HIDE}>
    {(ActionHideFun, { loading, error, data }) => {
      const variables = {
        contentGroupId,
        targetSnippetId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.contentGroup.addAction.id);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={ActionHideFun}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

ActionHide.propTypes = {
  contentGroupId: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  targetSnippetId: PropTypes.number.isRequired,
};

export default ActionHide;
